export default __webpack_public_path__ + "static/costume.inspirations-6dd20094281517d04306334c8d3a7264.jpg";